import { render, staticRenderFns } from "./classify_org.vue?vue&type=template&id=5fecce9e"
import script from "./classify_org.vue?vue&type=script&lang=js"
export * from "./classify_org.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports